import { createContext, SetStateAction, useContext, useState } from "react";
import { InstitutionsTypeType } from "@/shared/config/globals"
import { GetFinanceServicesFinancetypesResponseModel } from "@/features/accounts/finance/services/get-services-financetypes-model";

export interface Institution {
  industryCode: string;
  industryName: string;
  companyCode: string;
  companyName: string;
  branchCode: string;
  branchName: string;
  searchCodeList: string;
  maintenanceype: string;
}

export interface InstitutionsService {
  industryCode: string;
  industryName: string;
  companyCode: string;
  companyName: string;
  serviceCode: string;
  serviceName: string;
  branchCode: string;
  branchName: string;
  maintenanceType: string;
  scrapeType: number;
  sortOrder: string;
  siteUriLink: string;
  idInputComment: string;
  branchNameInputYn: string;
  branchNameInputTitle: string;
  branchNameInputValidYn: string; // 0：必須でない 1：必須
  enginScrapYn: string;
  idInputYn: string;
  idInputTitle: string;
  idInputValidYn: string; // 0：必須でない 1：必須
  id2InputYn: string;
  id2InputTitle: string;
  id2InputValidYn: string; // 0：必須でない 1：必須
  pwdInputYn: string;
  pwdInputTitle: string;
  pwdInputValidYn: string; // 0：必須でない 1：必須
  pwd2InputYn: string;
  pwd2InputTitle: string;
  pwd2InputValidYn: string; // 0：必須でない 1：必須
//  certificateYn: string;
//  certificateInfo: CertificateInfo[];
//  secCardUseYn: string;
//  secCardUseInfo: SecCardUseInfo[];
}

// interface CertificateInfo {
//   certificatePwdInputYn: string;
//   certificatePwdInputTitle: string;
//   certificatePwdInputValidYn: string;
//   queryPwdInputYn: string;
//   queryPwdInputTitle: string;
//   queryPwdInputValidYn: string;
// }

// interface SecCardUseInfo {
//   secCardClasf: string;
//   secCardTitle: string;
//   secCardDetailMsg: string;
//   secCardInputType: string;
//   oneCellInputCnt: string;
//   xCellInputCnt: string;
//   yCellInputCnt: string;
// }

interface InstitutionsContextType {
  institutionType: InstitutionsTypeType | undefined;
  institutions: Institution[];
  selectedInstitution: Institution | undefined;
  institutionsServices: InstitutionsService[];
  selectedInstitutionService: InstitutionsService | undefined;
  authType: "bank" | "crecaApi" | "crecaLookScrape" | "crecaLookApi" | "emoneyLookScrape" | "emoneyLookApi" | "ecshop" | "";
  companyCode: string;
  financeTypes: GetFinanceServicesFinancetypesResponseModel[];
  addinfoAccountsAccountGroupId: string;
  addinfoAccountsFinanceAccountId: string;
  setInstitutionType: React.Dispatch<SetStateAction<InstitutionsTypeType | undefined>>;
  setInstitutions: React.Dispatch<SetStateAction<Institution[]>>;
  setSelectedInstitution: React.Dispatch<SetStateAction<Institution | undefined>>;
  setInstitutionsServices: React.Dispatch<SetStateAction<InstitutionsService[]>>;
  setSelectedInstitutionService: React.Dispatch<SetStateAction<InstitutionsService | undefined>>;
  setAuthType: React.Dispatch<SetStateAction<"bank" | "crecaApi" | "crecaLookScrape" | "crecaLookApi" | "emoneyLookScrape" | "emoneyLookApi" | "ecshop" | "">>;
  setCompanyCode: React.Dispatch<SetStateAction<string>>;
  setFinanceTypes: React.Dispatch<SetStateAction<GetFinanceServicesFinancetypesResponseModel[]>>;
  setAddinfoAccountsAccountGroupId: React.Dispatch<SetStateAction<string>>;
  setAddinfoAccountsFinanceAccountId: React.Dispatch<SetStateAction<string>>;
  resetAddinfoAccountsState: () => void;
}

const InstitutionsContext = createContext<InstitutionsContextType | undefined>(undefined);

export const InstitutionsProvider = ({children}: {children: React.ReactNode}) => {
  const [institutionType, setInstitutionType] = useState<InstitutionsTypeType | undefined>(undefined);
  const [institutions, setInstitutions] = useState<Institution[]>([]);
  const [selectedInstitution, setSelectedInstitution] = useState<Institution | undefined>(undefined);
  const [institutionsServices, setInstitutionsServices] = useState<InstitutionsService[]>([]);
  const [selectedInstitutionService, setSelectedInstitutionService] = useState<InstitutionsService | undefined>(undefined);
  const [authType, setAuthType] = useState<"bank" | "crecaApi" | "crecaLookScrape" | "crecaLookApi" | "emoneyLookScrape" | "emoneyLookApi" | "ecshop" | "">("");
  const [companyCode, setCompanyCode] = useState<string>("");
  const [financeTypes, setFinanceTypes] = useState<GetFinanceServicesFinancetypesResponseModel[]>([]);
  const [addinfoAccountsAccountGroupId, setAddinfoAccountsAccountGroupId] = useState<string>("");
  const [addinfoAccountsFinanceAccountId, setAddinfoAccountsFinanceAccountId] = useState<string>("");

  const resetAddinfoAccountsState = () => {
    setFinanceTypes([]);
    setAddinfoAccountsAccountGroupId("");
    setAddinfoAccountsFinanceAccountId("");
  };

  return (
    <InstitutionsContext.Provider
      value={{
        institutionType,
        institutions,
        selectedInstitution,
        institutionsServices,
        selectedInstitutionService,
        authType,
        companyCode,
        financeTypes,
        addinfoAccountsAccountGroupId,
        addinfoAccountsFinanceAccountId,
        setInstitutionType,
        setInstitutions,
        setSelectedInstitution,
        setInstitutionsServices,
        setSelectedInstitutionService,
        setAuthType,
        setCompanyCode,
        setFinanceTypes,
        setAddinfoAccountsAccountGroupId,
        setAddinfoAccountsFinanceAccountId,
        resetAddinfoAccountsState,
      }}
    >
      {children}
    </InstitutionsContext.Provider>
  );
};

export const useInstitutionsContext = () => {
  const context = useContext(InstitutionsContext);
  if (!context) throw new Error("InstitutionsContext must be used within InstitutionsProvider");
  return context;
};